import { Rating } from '../types/enums/Rating';
import { AlertOption, RatingPreference } from '../types/email-preferences/EmailPreferences';
import { constants } from '../constants/constants';
import { Currency } from '../types/enums/Currency';
import { AlertEnabledState } from '../types/enums/AlertEnabledState';

const getDefaultRatingPreferences = (rating: Rating): RatingPreference => ({
    rating,
    isEUR: false,
    isUSD: false,
    minSize: constants.emailPreferencesSizeRange.min,
    maxSize: constants.emailPreferencesSizeRange.max
});

const isCurrencyActive = (ratingPreference: RatingPreference, currency: Currency) => {
    return (
        (currency === Currency.USD && ratingPreference.isUSD) ||
        (currency === Currency.EUR && ratingPreference.isEUR)
    );
}


const convertAlertEnabledStateToAlertOption = (value: AlertEnabledState, activeAlertOption = AlertOption.Instant) => {
    return value === AlertEnabledState.Disabled ? AlertOption.Never : activeAlertOption;
}

const alertOptionByPortfolioAlertEnabledState = {
    [AlertOption.Daily]: AlertEnabledState.Enabled,
    [AlertOption.Instant]: AlertEnabledState.Enabled,
    [AlertOption.Periodic]: AlertEnabledState.Enabled,
    [AlertOption.Weekly]: AlertEnabledState.Enabled,
    [AlertOption.Never]: AlertEnabledState.Disabled
}

const convertAlertOptionToAlertEnabledState = (value: AlertOption) => {
    return alertOptionByPortfolioAlertEnabledState[value];
}

export const emailPreferencesUtils = {
    getDefaultRatingPreferences,
    isCurrencyActive,
    convertAlertEnabledStateToAlertOption,
    convertAlertOptionToAlertEnabledState
};
